import { LuciusLogo } from '@/components/Custom/Logo/LuciusLogo';
import { formatDateWithLetterMonth } from '@/utils/date.utils';

interface PdfHeaderProps {
  title: string;
  date: string;
}

export const PdfHeader = ({ title, date }: PdfHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-12">
      <div className="flex items-center">
        <LuciusLogo />
      </div>
      <h1 className="text-2xl font-bold tracking-tight -mt-[17px]">{title}</h1>
      <p className="text-gray-600 -mt-[10px]">
        {formatDateWithLetterMonth({
          dateString: new Date(date).toDateString(),
          monthAbbreviated: false,
        })}
      </p>
    </div>
  );
};
